import type { UrlEntry, UrlRegion } from '@/types';

export type CoursePages = 'course/cy' | 'course/da' | 'course/ux' | 'course/wd';

export const urls: Record<CoursePages, Partial<Record<UrlRegion, UrlEntry>>> = {
  'course/cy': {
    de: 'cybersecurity',
    'de-en': 'cybersecurity',
    es: 'ciberseguridad',
    'es-en': 'cybersecurity',
    fr: 'cybersecurite',
    'fr-en': 'cybersecurity',
    gb: 'cybersecurity',
    nl: 'cybersecurity',
    'nl-en': 'cybersecurity',
    pt: 'ciberseguranca',
    'pt-en': 'cybersecurity',
    ww: 'cybersecurity',
  },
  'course/da': {
    de: 'data-analytics',
    'de-en': 'data-analytics',
    es: 'data-analytics',
    'es-en': 'data-analytics',
    fr: 'data-analytics',
    'fr-en': 'data-analytics',
    gb: 'data-analytics',
    nl: 'data-analytics',
    'nl-en': 'data-analytics',
    pt: 'data-analytics',
    'pt-en': 'data-analytics',
    us: 'data-analytics',
    ww: 'data-analytics',
  },
  'course/ux': {
    de: 'ux-ui-design',
    'de-en': 'ux-ui-design',
    es: 'diseno-ux-ui',
    'es-en': 'ux-ui-design',
    fr: 'ux-ui-design',
    'fr-en': 'ux-ui-design',
    gb: 'ux-ui-design',
    nl: 'ux-ui-design',
    'nl-en': 'ux-ui-design',
    pt: 'ux-ui-design',
    'pt-en': 'ux-ui-design',
    us: 'ux-ui-design',
    ww: 'ux-ui-design',
  },
  'course/wd': {
    de: 'webentwicklung',
    'de-en': 'web-development',
    es: 'desarrollo-web',
    'es-en': 'web-development',
    fr: 'developpement-web',
    'fr-en': 'web-development',
    gb: 'web-development',
    nl: 'web-development',
    'nl-en': 'web-development',
    pt: 'programacao-web',
    'pt-en': 'web-development',
    us: 'web-development',
    ww: 'web-development',
  },
};
